import { isEmpty } from "lodash-es";

import { axios, getBackendApiErrorResponse } from "~/core/axios";
import type { BackendApiResponse } from "~/core/types/backend-api-response.type";
import type { PaginationOptions } from "~/core/types/common.type";

import type { GetAllOpportunitiesQuery } from "~/lib/opportunities/types";

import type { Opportunity } from "../types/common";

export const getAllOpportunities = async (
  queryData: GetAllOpportunitiesQuery,
) => {
  const queryParams = new URLSearchParams();
  if (queryData.close_date_starts) {
    queryParams.set("close_date_starts", queryData.close_date_starts);
  }
  if (queryData.close_date_ends) {
    queryParams.set("close_date_ends", queryData.close_date_ends);
  }
  // if (queryData.sort_by) {
  //   queryParams.set("sort_by", queryData.sort_by);
  // }

  if (queryData?.filters?.length && queryData?.filters?.length > 0) {
    queryParams.append("filters", JSON.stringify(queryData.filters));
  }

  if (queryData.withDefaultView) {
    queryParams.append("withDefaultView", queryData.withDefaultView.toString());
  }

  if (queryData.pipeline_id) {
    queryParams.append("pipeline_id", queryData.pipeline_id);
  }

  if (queryData.sorting && !isEmpty(queryData.sorting)) {
    const modifiedSorting = queryData.sorting.map((sorting, index) => ({
      property_name: sorting.property_name,
      direction: sorting.order,
      serial: index + 1,
    }));
    queryParams.append("sortings", JSON.stringify(modifiedSorting));
  }

  if (queryData.limit) {
    queryParams.append("limit", queryData.limit.toString());
  }

  if (queryData.page) {
    queryParams.append("page", queryData.page.toString());
  }

  if (queryData.stage) {
    queryParams.append("stage_id", queryData.stage);
  }

  if (queryData.q) {
    queryParams.append("q", queryData.q.trim());
  }

  try {
    const { data } = await axios.get<
      BackendApiResponse<{
        opportunities: Opportunity[];
        metadata: PaginationOptions;
      }>
    >(`/opportunities?${queryParams.toString()}`);
    return data.data;
  } catch (error) {
    const err = getBackendApiErrorResponse(error);
    console.log(err);
    throw new Error(err?.data?.message || "Failed to fetch opportunities");
  }
};
